import { AlertType, CompType } from '@aloft/toolkit-shared';

export type AlertCompType = CompType;

export const getCompTypeLabel = (compType: AlertCompType): string =>
  compType === 'aiv' ? 'AIV' : 'ARV';

export const getCompTypeComparableLabel = (compType: AlertCompType): string =>
  compType === 'aiv' ? 'As-Is' : 'After-Repair';

export const getScopedAlertType = (base: string, compType?: AlertCompType): AlertType =>
  (compType ? `${base}${compType === 'aiv' ? 'Aiv' : 'Arv'}` : base) as AlertType;

export const getComparableDisplayName = (
  propertyID: string,
  compSequence?: string[],
): string => {
  const match = /^comp(\d+)$/.exec(propertyID);
  if (match) return `Comparable ${match[1]}`;

  const index = compSequence?.indexOf(propertyID);
  if (index !== undefined && index >= 0) return `Comparable ${index + 1}`;

  return propertyID;
};
